import { AxiosError } from 'axios'
import { BusinessError } from '@src/data/types'

interface ServerErrorPayload {
  message?: string
  type?: string
  fieldErrors?: Record<string, Record<string, string>>
}

export const extractWorksheetSaveErrors = (error: unknown, fallbackKey: string): BusinessError[] => {
  const response = (error as AxiosError | undefined)?.response
  const data = response?.data as ServerErrorPayload | string | undefined

  if (typeof data === 'string' && data.length > 0) {
    return [{ message: `common.errors.${data}` }]
  }

  if (data && typeof data === 'object') {
    if (data.type === 'BusinessValidationError' && data.message) {
      return [{ message: `common.errors.${data.message}` }]
    }

    if (data.type === 'FieldValidations' && data.fieldErrors) {
      const messages: BusinessError[] = []
      Object.values(data.fieldErrors).forEach((fieldError) => {
        Object.values(fieldError).forEach((errorKey) => {
          messages.push({ message: `common.errors.${errorKey}` })
        })
      })
      if (messages.length > 0) return messages
    }
  }

  if (response?.status === 409) {
    return [{ message: 'conflict.modificationConflict' }]
  }

  return [{ message: fallbackKey }]
}
